export const HEADER = "48px";
export const SIDEBAR = "208px";
/* Wide enough for the 32px avatar and the 24px menu icons to sit centred with
   room around them; 40px could not hold either, it only clipped them. */
export const SIDEBAR_COLLAPSED = "64px";
